import React, { SFC } from 'react'
import { Link } from 'react-router-dom'

export const AppHeader: SFC = () => (
  <nav className="navbar" role="navigation" aria-label="main navigation">
    <div className="navbar-brand">
      <a className="navbar-item" href="https://bulma.io">
        <img src="https://bulma.io/images/bulma-logo.png" width="112" height="28" />
      </a>
    </div>

    <div className="navbar-start">
      <Link className="navbar-item" to="/practice">
        Practice
        </Link>

      <Link className="navbar-item" to="/room">
        Create Room
        </Link>
    </div>

    <div className="navbar-end">
      <div className="navbar-item">
        <div className="buttons">
          <Link className="button is-primary" to="/signUp">
            <strong>Sign up</strong>
          </Link>
          <Link className="button is-light" to="/login">
            Log in
            </Link>
        </div>
      </div>
    </div>
  </nav>
)
